import { iconMap } from '../../common/components/Icon/iconMap';
import { IconNames } from '../../common/components/Icon/IconNames';
import { t } from '../../common/i18n';
import { DeadlineCategory, DeadlinePriority } from '../types';

const namespace = 'Deadlines';

/** Ikona pro danou kategorii termínu (fallback pro vlastní termíny bez vlastní ikony). */
export const categoryIcons: Record<DeadlineCategory, IconNames> = {
  revision: 'settings',
  document: 'document',
  finance: 'badge',
  legal: 'judgeHammer',
  meeting: 'users',
  other: 'flag',
};

const categoryOrder: DeadlineCategory[] = ['revision', 'document', 'finance', 'legal', 'meeting', 'other'];
const priorityOrder: DeadlinePriority[] = ['low', 'normal', 'high'];

export const categoryOptions = (): { value: DeadlineCategory; label: string }[] =>
  categoryOrder.map((value) => ({ value, label: t(`category.${value}`, namespace) }));

export const priorityOptions = (): { value: DeadlinePriority; label: string }[] =>
  priorityOrder.map((value) => ({ value, label: t(`priority.${value}`, namespace) }));

/** Doporučená ikona položky: ikona ze systémové definice (je-li renderovatelná), jinak ikona dle kategorie. */
export const resolveDeadlineIcon = (icon: string | null, category: DeadlineCategory): IconNames => {
  if (icon && icon in iconMap) {
    return icon as IconNames;
  }

  return categoryIcons[category] ?? 'flag';
};
